import { AlertTriangle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useI18n } from '@/lib/i18n'

interface ErrorMessageProps {
  message: string
  onRetry?: () => void
}

/** Friendly error notice with optional retry action. */
export function ErrorMessage({ message, onRetry }: ErrorMessageProps) {
  const { t } = useI18n()

  return (
    <div className="flex flex-col items-start gap-3 rounded-xl border border-destructive/30 bg-destructive/5 p-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-3">
        <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-destructive" aria-hidden />
        <p className="text-sm text-foreground">{message}</p>
      </div>
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry} className="shrink-0">
          {t('commonTryAgain')}
        </Button>
      )}
    </div>
  )
}
